import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "limit", "page", "endDate"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import { getPageOffset } from 'utils/pagination';
import contentKeys from './queryKeys';
import { PROFILE_ITEMS_PER_PAGE } from '.';
function useFetchUpcomingContent(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'all' : _ref$type,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? PROFILE_ITEMS_PER_PAGE : _ref$limit,
    page = _ref.page,
    endDate = _ref.endDate,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchUpcomingContent() {
    return _fetchUpcomingContent.apply(this, arguments);
  }
  function _fetchUpcomingContent() {
    _fetchUpcomingContent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('get', '/api/me/content/upcoming', _objectSpread({
              type: type,
              offset: getPageOffset({
                page: page,
                itemsPerPage: limit
              }),
              limit: limit
            }, endDate !== undefined && {
              endDate: endDate
            })));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchUpcomingContent.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread({
      queryKey: contentKeys.myUpcomingContent(type, page, endDate),
      queryFn: fetchUpcomingContent
    }, queryOptions)),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  var _ref2 = data || {},
    items = _ref2.items,
    total = _ref2.total,
    nextOffset = _ref2.nextOffset;
  return _objectSpread({
    items: items,
    total: total,
    nextOffset: nextOffset
  }, result);
}
export default useFetchUpcomingContent;